

import { Injectable } from "@angular/core";
import { ApiService } from "@bt/core";
import { Observable } from "rxjs/observable";
import { IResponse, ConfirmationSessionDto } from "@bt/shared";

@Injectable()
export class RestoreService {
  constructor(private api: ApiService) { }

  public register(email: string): Observable<IResponse<ConfirmationSessionDto>> {
    return this.api.postAnonym<ConfirmationSessionDto>("api/users/restore", {
      email: email
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/public/restore/restore.service.ts